import raf              from 'raf';
import helperA11y       from 'shared/mixins/helper-a11y';

/**
 * @module formValidation
 */
const selector = 'form,[type="date"],[type="number"],[type="url"],[type="email"],[type="tel"],[pattern],[required],[data-js-validate-form],[data-js-validate-custom], [data-js-validate-multi], [data-js-validate-multi-group]';
const formValidation = function(el, app) {

    const a11yHelper = helperA11y(app);

    const $el               = $(el);
    const $msgAny           = $el.next('.Ge-Validation');
    const $msgRegular       = $el.next('.Ge-Validation:not(.Ge-Validation--exception)');
    let   $form             = false; // $el, but only if this is bound to a form (not in input) - just for clarity.
    let   val               = null;
    let   formValidated     = false;
    let   $formInputs       = []; // used to collect all the inputs inside a form
    let   $formInputGroups = [];
    let   status            = null;
    let   blurTimer         = null; // a setTimeout ref, allowing us to lose focus on an input for microseconds without triggering validation
    const tag               = $el.prop("tagName");
    const type              = $el.attr('type');
    const required          = $el.attr('required');
    const pattern           = $el.attr('pattern');
    const noBlur            = $el.attr('disableBlur');

    const init = function() {
        if (tag === 'FORM') {
            $form = $el;
            // don't include any forms that are already marked as novalidate
            if ($form.attr('novalidate') !== undefined) {
                return;
            }
            // remove the default HTML5 validation (so we have a consistent interface and better control)
            $form.attr('novalidate',true);
            // we need to know when all the inputs contained in the form are ready (if we register events before they're all ready, bad things could happen, but more common, the error message banner could fire before the user has even interacted with the form).
            // find how many validatable inputs are contained in the form
            $formInputs = $form.find(selector.replace('form,',''));
            const formInputsLength = $formInputs.length;
            // we need to know how many multi field divs there are
            $formInputGroups = $form.find('[data-js-validate-multi-group]');
            // now wait for each input to fire a "ready" event directed at this form, and when they're all accounted for, make the form ready
            let inputCounter = 0;

            $form.on('formValidateInputReady',function(ev) {
                inputCounter++;
                // was that the last input in the form that was initialised?
                if (inputCounter >= formInputsLength) {
                    // register submit events (after all inputs are ready - partly because form-restore.js might be restoring data from localstorage 200ms after the field is initialised - which will cause a blur event, possibly triggering the error banner before the user has interacted with the form)
                    setTimeout(registerFormEvents,500);
                    // mark form as ready
                    $form.addClass('Ge-Validation-Form--ready');
                }
            });
            // backup - if we wait longer than a 2 seconds for all the field to initialise, somthing might have gone wrong, and initialise anyway
            setTimeout(function formValidateInputFallback() {
                if (!$form.hasClass('Ge-Validation-Form--ready')) {
                    registerFormEvents();
                    $form.addClass('Ge-Validation-Form--ready');
                }
            },2000);
        } else {
            // register all the state change events on this input
            registerFieldStates();
            // mark the field as ready
            $el.addClass('Ge-Validation-Input--ready');
            // if this field has an error message directly following it, make it ready
            $el.find('~.Ge-Validation:not(.Ge-Validation--exception)').addClass('Ge-Validation--ready');
            // if this field is in a label pattern, prep the validation icon
            if ($el.closest('.Ge-Label').length) {
                $el.closest('.Ge-Label').append('<span class="Ge-Label-Validation"></span>');
            }
            // is this is being validated by ajax, stop here, we don't want to carry out regular validation on this input
            if ($el.attr('data-js-validate-ajax') !== undefined) {
                return;
            }
            // register all the validation event listeners
            registerFieldEvents();
            // validate the field on init (if it's not empty)
            fieldValidate(false,true);
            // tell the enclosing form that this input is ready (used to tell the form when all inputs are ready)
            $el.closest('form').trigger('formValidateInputReady');
        }
    };

    //**** FORM  ****//

    const registerFormEvents = function() {
        $form.on('submit',function(ev,obj) {
            formSubmit(ev,(obj ? obj : false));
        });
        $form.on('formValidate',formSubmit);
        $form.on('formValidateCheckMessage',formMessage); // ??
    };

    // once a form is submitted, check everything contained to see is anything is invalid.
    const formSubmit = function(ev,args) {
        // arguments to the event?
        let submitCallback = false;
        if (args) {
            submitCallback = (args.submit ? args.submit : false );
        }
        // start assuming everything is valid
        markValid();
        // if the form is genuinely valid, this will resubmit it and push it through the green path.
        if (formValidated) {
            // send to callback?
            if (submitCallback) {
                submitCallback();
                return;
            // return true and let the form submit normally
            } else {
                return true;
            }
        }
        const submitAgain = function() {
            formValidated = true;
            $form.trigger('formIsValid');
            // timeout to allow the GA beacon to function.
            setTimeout(function submitAgainTimeout() {
                $form.submit();
            },100);
        };
        formValidated = false;

        // Do we have any divs with fields inside them, right now only applicable to checkbox group.
        if($formInputGroups.length) {
          // if there are inputs in need of validation testing, stop the form submit
          ev.preventDefault();
          // Future improvement, take type here and apply logic to its particular semantics.
          // Gather all inputs inside of the divs:
          $formInputGroups.map( (i, div) => {
            const $multiInputDiv = $(div);
            // Get type of multi div already
            const $inputType = $multiInputDiv.attr('data-js-validate-multi-type');
            if (!$inputType) {
              
              return;
            }

            // const $firstInputInDiv =  $($multiInputDiv.find('input')[0]);
            // const inputType = $firstInputInDiv.attr('type');
            // if ( inputType === 'checkbox' || inputType === 'radio' ) {
                // Validate
                let validatePassed = validateGroupInputs($multiInputDiv.find('input'));
                if (!validatePassed) {
                    // console.log( "Marking " + $multiInputDiv.attr("data-js-multi-group-validation-name") + "[" + $multiInputDiv.length + "] as invalid");
                    // At this point add event listeners for checkboxes,
                    markInValid(true);
                    formMessageReCheck(ev);
                    // Add red box around group to mark as invalid
                    setTimeout( () => $multiInputDiv.addClass("Ge-Form-Checkboxes--validation-error"), 150);
               } else {
                // console.log( "Marking " + $multiInputDiv.attr("data-js-multi-group-validation-name") + "[" + $multiInputDiv.length + "] as valid");
                markValid(true);
                    $form.trigger('formIsValid');
                    formMessageReCheck(ev);
                    setTimeout( () => $multiInputDiv.removeClass("Ge-Form-Checkboxes--validation-error"), 150);
              }
            // }
          });
        }

        // do any inputs exist in this form that need validation?
        if ($formInputs.length) {
            // if there are inputs in need of validation testing, stop the form submit
            ev.preventDefault();
            // trigger all fields to check validation
            $formInputs.trigger('fieldValidate');
            // give some time for the event to propagate
            setTimeout(function formValidateTimeout () {
                // any invalid inputs in this form?
                if ($formInputs.filter('[aria-invalid="true"]:not([disabled])').length) {
                    formMessage();
                    markInValid();
                    return;
                } else {
                    // send to callback?
                    if (submitCallback) {
                        submitCallback();
                        return;
                    // re-submit skipping validation
                    } else {
                        submitAgain();
                    }
                }
            },100);
        // this form has no fields in need of validation, pass through the green path.
        } else {
            // send to callback?
            if (submitCallback) {
                submitCallback();
                return;
            // re-submit skipping validation
            } else {
                submitAgain();
            }
        }
    };

    let   arrayOfIdsPrev = [];
    // if a form is invalid, we need to assemble a human readable message and display it.
    // This method can be triggered by form submission, or by trying validation on a single input, so it could be called if the form is actually valid - don't assume it must be invalid.
    const formMessage = function() {
        // this is only applied to a form.
        if (!$form) {
            return;
        }
        // find the invalid fields, exclude multi groups
        // const $inValidFields = $form.find('[aria-invalid="true"]:not([disabled]):not([data-js-validate-multi]):not([data-js-validate-multi-type=radios])');
        const $inValidFields = $form.find('[aria-invalid="true"]:not([disabled]):not([novalidate])');
        // find the invalid groups, a group is a bunch of inputs under a div where validation might med triggered
        // if no invalid fields, mark as valid and exit!
        if (!$inValidFields.length) {
            markValid();
            // check to see if the form error message banner is currently active (from a previous error message), and now that we've cleared all errors, remove it
            if ($('#msg-formError.Ge-Msg--active')) {
                app.trigger('msgGlobalKill',['formError']);
            }
            return;
        }
        // otherwise...
        // find the corresponding label for each invalid field
        let   arrayOfLabels = [];
        let   arrayOfIds = [];

        $.each($inValidFields, function formMessageLoop(index, input) {
            const $input = $(input);
            const $labelParent = $input.closest('label:not(.Ge-Validation):not(.Ge-Msg),.Ge-Label');
            let   label = null;
            // if the input is wrapped in a valid label
            if ($labelParent.length) {
                // if this label is a standard ".Ge-Label" pattern
                if ($labelParent.hasClass('Ge-Label')) {
                    label = $labelParent.find('.Ge-Label-Text').text();
                // else it's a more generic label wrapper - read the whole label
                } else {
                    // clone the label, 'cos we're going to do some manipulation
                    const $labelClone = $labelParent.clone();
                    // remove any validation message in the label
                    $labelClone.find('.Ge-Validation').remove();
                    // find the remaining text in the label and use that
                    label = $labelClone.text();
                }
            // else if there is a corresponding label in the page (it's just not wrapping the input, but using the "for=id" pattern instead)
            } else if ($form.find('[for="' + $input.attr('id') + '"]').length) {
                label = $form.find('[for="' + $input.attr('id') + '"]').text();
            // else, find out if this is a group validation
            } else if (typeof $input.attr('data-js-validate-multi-group') !== undefined &&
                       typeof $input.attr('data-js-multi-group-validation-name') !== undefined &&
                       $input.attr('data-js-multi-group-validation-name') &&
                       $input.attr('data-js-multi-group-validation-name').length  ) {
               label = $input.attr('data-js-multi-group-validation-name');
            // else, just take the input "name" value and hope that makes some sense.
            } else {
               label = $input.attr('name');
            }

            if( label ){
                // trim
                label = label.trim();
                // summarize
                if (label.length > 35) {
                    label = label.substr(0,29) + '...';
                }


                // add to the list
                arrayOfLabels.push(label);
                // ids
                let id = $input.attr('name') || $input.attr('id') || label.replace(',',' ');
                arrayOfIds.push(id);
            }
            else {
                console.warn( "No label");
                console.log( $input[0].outerHTML );
            }
        });


        // stick the error message in a global message (sticky, permament, dismissable)
        const msg = 'Kontrollera ' + arrayOfLabels.join(', ');
        app.trigger('msgGlobal',[msg,'formError','error',true]);

        // beacon if it's changed
        if (JSON.stringify(arrayOfIdsPrev) !== JSON.stringify(arrayOfIds)) {
            $form.trigger('formIsInValid',[arrayOfIds]);
            arrayOfIdsPrev = arrayOfIds;
        }
    };

    // re-evaluate the whole form error message.
    const formMessageReCheck = function(ev) {
        // only re-evaluate message if the event triggering this is a user event, not when stepping through all fields.
        if (!ev) {
            return;
        }
        // only update the form error message if the user has tried and failed to submit it.
        // Pinging up a big "error" banner every time the user tweaks a form before they're satisfied and submitted it with it is really annoying...
        if (!$('#msg-formError.Ge-Msg--active').length) {
            return;
        }
        if (tag !== 'FORM') {
            // minor delay, because changing this input might have an effect on another input that will need re-evaluating
            // (eg, ticking a checkbox might undisabled a text field that needs re-evalutation, but the DOM might not register the change until the next frame)
            raf(function tick1() {
                raf(function tick2() {
                    $el.trigger('formValidateCheckMessage');
                });
            });
        }
    };

    //**** INPUTS  ****//

    const registerFieldStates = function(ev) {
        $el.on('fieldInValid',      markInValid);
        $el.on('fieldInValidNoMessage', markInValidNoMsg);
        $el.on('fieldValid',        markValid);
        $el.on('fieldWarn',         markWarning);
        $el.on('fieldNothing',      markNothing);
        $el.on('fieldBusy',         markBusy);
        $el.on('fieldNotBusy',      markNotBusy);
    };

    const registerFieldEvents = function(ev) {
        if (['date'].indexOf(type) >= 0) {
            $el.on('change',        fieldValidate);
            $el.on('keyup',         fieldKeystroke);
        } else if (['radio','checkbox'].indexOf(type) >= 0) {
            $el.on('change',        fieldValidate);
        } else if (['file'].indexOf(type) >= 0) { 
            $el.on('change',        fieldValidate);
        } else if (tag === 'SELECT') {
            $el.on('change',        fieldValidate);
        } else if( tag === "INPUT" ) {
            $el.on('keyup',         fieldKeystroke);
        }

        $el.on('blur',              fieldValidateOnBlur);
        $el.on('focus',             fieldDontValidateOnBlur);
        $el.on('fieldValidate',     fieldValidate);
        $el.on('fieldValidateForce',fieldValidateForce);

    };

    // allows us to lose focus on an input for microseconds without triggering validation
    const fieldValidateOnBlur = function() {
        // always set this to false so its enabled as standard
        let shouldCancelBlurEvent = false;
        shouldCancelBlurEvent = $el.data("disable-validate-blur");
        // if client chooses to cancel this functionality, do nothing
        if(!shouldCancelBlurEvent) {
            
            blurTimer = setTimeout(function() {
                // allow a tiny setTimeout, just incase we lose focus and gain it back again
                fieldValidate();
            },500);
        } else {
            clearTimeout(blurTimer);
        }
   
    };
    const fieldDontValidateOnBlur = function() {
        
    };

    // on every change to the input (eg, update the validity status whilst typing in the field)
    const fieldKeystroke = function(ev) {
        if (typeof $el.attr('novalidate') !== 'undefined') {
            formMessageReCheck(ev);
            return;
        }
        val = $el.val();
        
        
        let stepSuccess = false;

        // custom validation
        if (typeof $el.attr('data-js-validate-custom') !== 'undefined') {
            fieldValidateCustom(ev,true);
        } else {
            // console.dir(el);
            const isValid = el.checkValidity();
            // if it's valid, let the user know the infor they've entered is good.
            // eg, in anläggnings id, you need to type 14 digits. It's best to know when you've typed the right amount, without having to tap out of the field to re-evaluate the field.
            if (isValid) {
                markValid();
                formMessageReCheck(ev);
            // if **no** validaty status has been applied to this field yet it's probably untouched.
            // don't mark as invalid. Everyone hates being told their wrong just because they haven't finished typing.
            } else if (!status && !isValid) {
                formMessageReCheck(ev);
            // but.. if the field has any sort of known status and it's now seen as invalid, mark it as invalid
            // eg typing in a field the correct number of digits and the green tick appearing. If you keep typing, it should now tell you it's no longer valid.
            } else if (!isValid) {
                markInValid();
                formMessageReCheck(ev);
            }
        }
    };

    // on the "final" change to the input (ie, on blur, or when the whole value needs validating)
    const fieldValidate = function(ev,ignoreBlank) {

        // if checks or radios are a part of a group, exit, no validation required.
        if (typeof $el.attr('novalidate') !== 'undefined') {
            formMessageReCheck(ev);
            return;
        }

        if( !$el.is( ":visible" ) ){
            markValid();
            return;
        }

        // on page load, empty fields shouldn't be marked as invalid, even if they're required (that goes for radio and checkboxes too).
        val = $el.val();
        if ( ignoreBlank && (!val.length || type === 'radio' || type === 'checkbox' ) ) {
            return;
        }
        

        // custom validation
        if (typeof $el.attr('data-js-validate-custom') !== 'undefined') {
            fieldValidateCustom(ev);

        // carry out multi validation checks on the container event
        } else if (typeof $el.attr('data-js-validate-multi-group') !== 'undefined' ) {
            if(ev && ev.currentTarget) {
              const inputs = $(ev.currentTarget).children().find('input');
              multiValueValidate(ev, inputs);
            }
        } else if (typeof $el.attr('data-js-validate-multi') !== 'undefined' ) {
          if(ev && ev.currentTarget) {
            const inputs = $(ev.currentTarget).parents('[data-js-validate-multi-group]').find('input');
            multiValueValidate(ev, inputs);
          }
        } else {
          fieldValidateForce(ev);
        }
    };

    // force a validity check, overriding any custom validation or if the field is empty.
    // Will check validity against HTML5 patterns (eg, type="email", required, pattern)
    // then mark as valid or invalid, and update any global error notification
    const fieldValidateForce = function(ev) {
        // if field is invalid
        if (!el.checkValidity()) {
            markInValid();
        // if field is valid
        } else {
            markValid();
        }
        formMessageReCheck(ev);
    };

    // multi-validation method, right now only "required" validation is supported
    const multiValueValidate = function(ev, $inputElems) {
      // Validate
      if ($inputElems) {

        let isValid = validateGroupInputs($inputElems);
        const closestGroupContainer = $(ev.currentTarget).closest('[data-js-validate-multi-group]');
        if (!isValid) {
            markInValid(true);
            formMessageReCheck(ev);
            // Add red box around group to mark as invalid
            closestGroupContainer.addClass("Ge-Form-Checkboxes--validation-error");
            setChildrenUntouched($inputElems);
        } else {
          markValid(true);
          formMessageReCheck(ev);
          closestGroupContainer.removeClass("Ge-Form-Checkboxes--validation-error");
        }
      }
    };

    const setChildrenUntouched = function($inputElems) {
      $inputElems.each( function (i, item) {
        $(item).attr('aria-invalid',false);
      });
    };

    // custom validation method from elsewhere
    const fieldValidateCustom = function(ev,keyup) {
        const methodName = $el.attr('data-validate-custom-method');
        const method = window[methodName];
        if (methodName && methodName.length) {
            const isValid = method($el);
            // if this is a keyup event, the field is invalid and it hasn't yet been given a status, hold your horses.
            if (keyup && !status && !isValid) {
                formMessageReCheck(ev);
            // if field is invalid
            } else if (!isValid) {
                markInValid();
                formMessageReCheck(ev);
            // if field is valid
            } else {
                markValid();
                formMessageReCheck(ev);
            }
        }
    };

    // For single field validations
    // mark this input as invalid
    const markInValid = function(groupPropagate = false) {
        status = 'invalid';
        $el.data('validity-status',status);
        $el.attr('aria-invalid',true);
        // trigger further actions via events
        $el.trigger('formValidateFieldInvalid');
        // deal with validation msgs
        $msgRegular.attr('aria-hidden',false);
        a11yHelper.show($msgRegular);

        // If this is set, find closest group container, perform same operations.
        if (groupPropagate) {
          let $parentGroupContainer = $($el).parents('[data-js-validate-multi-group]');

          status = 'invalid';
          $parentGroupContainer.data('validity-status',status);
          $parentGroupContainer.attr('aria-invalid',true);

          // Show next error message if groupPropagate
          $parentGroupContainer.next('span').attr('aria-hidden', false);
        }
    };

    // For single field validations
    // mark this input as valid
    const markInValidNoMsg = function(groupPropagate = false) {
        status = 'invalid';
        $el.data('validity-status',status);
        $el.attr('aria-invalid',true);
        // trigger further actions via events
        $el.trigger('formValidateFieldInvalid');

        // If this is set, find closest group container, perform same operations.
        if (groupPropagate) {
          let $parentGroupContainer = $($el).parents('[data-js-validate-multi-group]');

          status = 'invalid';
          $parentGroupContainer.data('validity-status',status);
          $parentGroupContainer.attr('aria-invalid',true);

          // Show next error message if groupPropagate
          $parentGroupContainer.next('span').attr('aria-hidden', false);
        }
    };

    // mark this input as valid
    const markValid = function(groupPropagate = false) {
        status = 'valid';
        $el.data('validity-status',status);
        $el.attr('aria-invalid',false);
        // deal with validation msgs
        $msgRegular.attr('aria-hidden',true);
        a11yHelper.hide($msgRegular);
        // If this is set, find closest group container, perform same operations.
        if (groupPropagate) {
          let $parentGroupContainer = $el.parents('[data-js-validate-multi-group]');

          status = 'valid';
          $parentGroupContainer.data('validity-status',status);
          $parentGroupContainer.attr('aria-invalid',false);

          // Show next error message if groupPropagate
          $parentGroupContainer.next('span').attr('aria-hidden', true);
        }
    };

    // mark this input as "warning" (ie, not valid or invalid, but somewhere inbetween)
    const markWarning= function() {
        status = 'warning';
        $el.data('validity-status',status);
        //boolean values can't be in this "being edited" state
        if (['radio','checkbox'].indexOf(type) >= 0) {
            markInValid();
            return;
        }
        $el.attr('aria-invalid','warn');
        // deal with validation msgs
        $msgRegular.attr('aria-hidden',true);
        a11yHelper.hide($msgRegular);
    };

    // remove any validity marking from this input
    const markNothing = function() {
        status = null;
        $el.data('validity-status',status);
        $el.removeAttr('aria-invalid');
        // deal with validation msgs
        $msgRegular.attr('aria-hidden',true);
        a11yHelper.hide($msgRegular);
    };

    // mark this input as busy
    const markBusy = function() {
        status = null;
        $el.data('busy-status',true);
        $el.attr('aria-invalid',false).attr('aria-busy',true);
        // deal with validation msgs
        $msgRegular.attr('aria-hidden',true);
        a11yHelper.hide($msgRegular);
    };

    // mark this input as not busy
    const markNotBusy = function() {
        status = null;
        $el.data('busy-status',false);
        $el.attr('aria-busy',false);
    };

    // The use of strategy is with future requirement i
    const validateGroupInputs = ($elems) => {
      if (!$elems) {
        
        return;
      }
      const inputsToValidate = $elems;
      // If we have a checked value, filter will return with length
      let filteredInputs = inputsToValidate.filter( (i, input) => {
        return $(input).is(':checked');
      });
      return filteredInputs.length ? true : false;
    };

    return {
        init: init()
    };
};

formValidation.selector = selector;

export default formValidation;
